import { Method } from 'axios';
import AbstractGetTask from '@vertical-plus/vue-js-api-platform/dist/model/task/abstract-get-task';
import ClientDto from '@/model/entity/client/client-dto';
import Exception from '@vertical-plus/vue-js-api-platform/dist/model/exception/exception';
import JobDto from '@/model/entity/job/job-dto';
import TaskHelper from '../task-helper';
import TaskParamsInterface from '@vertical-plus/vue-js-api-platform/dist/model/task/task-params-interface';
import Timesheet from '@/model/entity/audit/timesheet';
import TimesheetDto from '@/model/entity/audit/timesheet-dto';
import TimesheetSearchConditionsInterface from '@/model/vo/audit/timesheet-search-conditions-interface';
import TimesheetSearchResultsVo from '@/model/vo/audit/timesheet-search-results-vo';

export default class GetTimesheetsTask extends AbstractGetTask
{
    public searchConditions?: TimesheetSearchConditionsInterface;

    public async run(): Promise<TimesheetSearchResultsVo>
    {
        const response = await this.execute();

        if (response.status === this.successCode)
        {
            const searchResults = this.parseSearchResults(response);
            const meta = response.data['hydra:meta'];

            const timesheets: Timesheet[] = [];

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            for (const timesheetDto of (searchResults.results as any[]))
            {
                this.addAssociations(meta, timesheetDto);

                const dto = timesheetDto as TimesheetDto;

                timesheets.push(new Timesheet(dto));
            }

            searchResults.results = timesheets;

            return searchResults as TimesheetSearchResultsVo;
        }

        switch (response.status)
        {
        case 401:
            throw new Error(Exception.InvalidDetails);

        default:
            throw new Error(Exception.UnknownError);
        }
    }

    protected get url(): string
    {
        return '/timesheets';
    }

    protected get params(): TaskParamsInterface|null
    {
        if (!this.searchConditions)
        {
            return null;
        }

        return this.generateParamsFromData(this.searchConditions);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private addAssociations(meta: any, timesheetDto: any)
    {
        // Add the user
        timesheetDto.user = TaskHelper.getItemFromMeta(meta.users, timesheetDto.user);

        // Add the job
        const jobDto = TaskHelper.getItemFromMeta(meta.jobs, timesheetDto.job) as JobDto|null;
        if (jobDto)
        {
            // Add the client
            jobDto.client = TaskHelper.getItemFromMeta(meta.clients, jobDto.client) as ClientDto|null;

            // Add the job to the timesheet
            timesheetDto.job = jobDto;
        }
    }
}